The details of the conflicting webhook subscription.
